<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Vergi Dairesi</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="Vergi Dairesi" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="ProvinceId" :watch="province">
                <v-select-list v-model="province" :options="provinces" label="Name" placeholder="İl"></v-select-list>
            </v-validator>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            provinces:[]
        }
    },
    mounted(){
        this.getProvinces()
    },
    methods:{
        getProvinces(){
            //TURKEY
            SystemDataApi.ProvinceByCountry('43776974-AB91-4FA2-B2AC-87B5E8939241').then(response=>{
                this.provinces = response.data.Data
            })
        },
    },
    computed:{
        province:{
            get:function(){
                return this.provinces.find(b=>b.Id==this.value.ProvinceId)
            },
            set:function(value){
                this.value.ProvinceId = value?.Id || null
            }
        },
    }
}
</script>
